__turbopack_context__.v({
  "inner": "SuggestEventDialog-module-scss-module__DdnGnq__inner",
  "root": "SuggestEventDialog-module-scss-module__DdnGnq__root",
  "title": "SuggestEventDialog-module-scss-module__DdnGnq__title",
});
